import { createContext } from 'react';

export type TParamContext = {
  BASIC_MEMBERSHIP_PLAN: string;
  PREMIUM_MEMBERSHIP_PLAN: string;
  DOCUSEAL_RULES_AND_REGULATION_SRC: string;
  DOCUSEAL_MEMBERSHIP_APP_SRC: string;
  DOCUSEAL_MEMBERSHIP_AGREEMENT_SRC: string;
  STRIPE_ACCESS_KEY: string;
};

export const ParamContext = createContext<TParamContext | null>(null);
